import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { GRPCEnvironment } from './class/environment.class';
import { AccountGrpcContractProvider } from './providers/account.service.provider';
import { ActionsPlanBhGrpcContractProvider } from './providers/actions-plan.service.provider';
import { AuthGrpcContractProvider } from './providers/auth.service.provider';
import { AuthV2GrpcContractProvider } from './providers/auth-v2.service.provider';
import { DataContentGrpcContractProvider } from './providers/data-content.service.provider';
import { GRPC_ENVIRONMENT, GRPCEnvironmentProvider } from './providers/environment.provider';
import { LocalizationGrpcContractProvider } from './providers/localization.service.provider';
import { OrderV2GrpcContractProvider } from './providers/order-v2.service.provider';
import { PhoneBhGrpcContractProvider } from './providers/phone.service.provider';
import { PillFormsGrpcContractProvider } from './providers/pill-forms.service.provider';
import { SubstanceGrpcContractProvider } from './providers/substance.service.provider';
import { SubstanceUserGrpcContractProvider } from './providers/substance-user.service.provider';
import { SurveyBhUserGrpcContractProvider } from './providers/survey-user.service.provider';
import { UserDataGrpcContractProvider } from './providers/user-data.service.provider';
import { UserMedcardGrpcContractProvider } from './providers/user-medcard.service.provider';
import { UserTreatmentsScheduleGrpcContractProvider } from './providers/user-treatments-schedule.service.provider';
import { AccountGrpcContractService } from './services/account.service';
import { ActionsPlanBhGrpcContractService } from './services/actions-plan.service';
import { AuthGrpcContractService } from './services/auth.service';
import { AuthV2GrpcContractService } from './services/auth-v2.service';
import { DataContentGrpcContractService } from './services/data-content.service';
import { HeaderService } from './services/header.service';
import { LocalizationGrpcContractService } from './services/localization.service';
import { OrderV2GrpcContractService } from './services/order-v2.service';
import { PhoneGrpcContractService } from './services/phone.service';
import { PillFormsGrpcContractService } from './services/pill-forms.service';
import { SubstanceGrpcContractService } from './services/substance.service';
import { SubstanceUserGrpcContractService } from './services/substance-user.service';
import { SurveyBhUserGrpcContractService } from './services/survey-user.service';
import { UserDataGrpcWebContractService } from './services/user-data.service';
import { UserMedcardGrpcContractService } from './services/user-medcard.service';
import { UserTreatmentsScheduleGrpcContractService } from './services/user-treatments-schedule.service';

export function provideGrpcConfig<T extends GRPCEnvironment>(environment: T): EnvironmentProviders {
  return makeEnvironmentProviders([
    GRPCEnvironmentProvider,
    PhoneBhGrpcContractProvider,
    LocalizationGrpcContractProvider,
    UserMedcardGrpcContractProvider,
    UserDataGrpcContractProvider,
    SubstanceGrpcContractProvider,
    ActionsPlanBhGrpcContractProvider,
    AuthGrpcContractProvider,
    OrderV2GrpcContractProvider,
    AuthV2GrpcContractProvider,
    AccountGrpcContractProvider,
    PillFormsGrpcContractProvider,
    UserTreatmentsScheduleGrpcContractProvider,
    DataContentGrpcContractProvider,
    SurveyBhUserGrpcContractProvider,
    SubstanceUserGrpcContractProvider,

    LocalizationGrpcContractService,
    PhoneGrpcContractService,
    UserMedcardGrpcContractService,
    UserDataGrpcWebContractService,
    SubstanceGrpcContractService,
    ActionsPlanBhGrpcContractService,
    AuthGrpcContractService,
    OrderV2GrpcContractService,
    AuthV2GrpcContractService,
    AccountGrpcContractService,
    PillFormsGrpcContractService,
    UserTreatmentsScheduleGrpcContractService,
    DataContentGrpcContractService,
    SurveyBhUserGrpcContractService,
    SubstanceUserGrpcContractService,
    HeaderService,
    {
      provide: GRPC_ENVIRONMENT,
      useValue: environment,
    },
  ]);
}
